export default __webpack_public_path__ + "static/media/Transactions.29557247.svg";